.providers {
  display: grid;
  gap: 8px;
  margin-bottom: 16px;
}

.provider {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 0 16px;
  border: 1px solid var(--line);
  border-radius: var(--radius-field);
  color: var(--text);
  font-weight: 500;
  text-decoration: none;
}

.provider:hover {
  border-color: var(--accent);
}

.divider {
  margin-top: 4px;
  color: var(--muted);
  font-size: 13px;
  text-align: center;
}
